/**
 * Vitals charting entry DTOs
 * Extracted from src/services/patientmr/charting.service.ts
 */

import { BaseEntryData } from './chart-entry.dto';

export const PAIN_SCALES = ['FLACC', 'FACES', 'NRS'] as const;
export type PainScale = typeof PAIN_SCALES[number];

/** Phase 18 M8: pain on a named scale, score 0–10 */
export interface VitalsPain {
  scale: PainScale;
  score: number;
}

/**
 * Vitals data structure. Phase 18 M1: blank values are omitted (never 0), so every
 * measurement is optional; the server requires at least one.
 */
export interface VitalsData extends BaseEntryData {
  temperature?: number;
  bloodPressure?: string;
  pulse?: number;
  respiratoryRate?: number;
  o2Saturation?: number;
  /** Older entries stored a bare number */
  pain?: VitalsPain | number;
  o2FlowLpm?: number;
}

/** Phase 18 M1 plausibility bounds (contract.md M1); the server checks the same */
export const VITALS_BOUNDS = {
  temperature: { min: 80, max: 110, label: '80–110 °F' },
  pulse: { min: 20, max: 300, label: '20–300 bpm' },
  respiratoryRate: { min: 0, max: 120, label: '0–120 /min' },
  o2Saturation: { min: 0, max: 100, label: '0–100 %' },
  painScore: { min: 0, max: 10, label: '0–10' },
  o2FlowLpm: { min: 0, max: 60, label: '0–60 L/min' },
} as const;

export const BLOOD_PRESSURE_PATTERN = /^\d{2,3}\/\d{2,3}$/;
